import { Stack, Box } from '@chakra-ui/react'
import { SectionTitle } from '@!/Store/Common/components'
import { ScrollableContent } from '@!/Store/Home/components'
import { Title } from './Title'

/* 横スクロール型のタイトルリスト */
export const ScrollableTitles = ({ titles, sectionTitle, url, gtmClick }) => {
  return (
    <Stack gap={0} mx={4}>
      <SectionTitle title={sectionTitle} url={url} gtmClick={gtmClick} />
      <ScrollableContent>
        <Stack direction="row" gap={0}>
          {titles.map((title) => (
            <Box key={`${sectionTitle}-${title.title_id}`} mr={3}>
              <Title titleId={title.title_id} titleName={title.title_name} imageUrl={title.image_url} gtmClick={gtmClick} />
            </Box>
          ))}
        </Stack>
      </ScrollableContent>
    </Stack>
  )
}
